import { Chart, registerables } from 'chart.js';
import Chartkick from 'chartkick';

Chart.register(...registerables);
Chartkick.use(Chart);
window.Chartkick = Chartkick;
